export default __webpack_public_path__ + "static/media/profileBanner.ca8bd230.jpg";